import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare function videojs(id: any, options: any, ready: any): any;

import { VgAPI } from 'videogular2/core';
import { DomainService } from 'app/core/services/domain.service';
import { ConfigService } from 'app/core/services/config.service';
import { LicenseService } from 'app/core/services/license.service';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
@Component({
  selector: 'itpx-evaluation-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class EvaluationVideoComponent extends LoadingPage {
  type: string;
  addPlugins(): any {
    // videojs.getPlayer().brand({
    //   image: this.licenseService.getLogo(),
    //   title: 'Logo Title',
    //   destination: 'http://www.leapest.com',
    //   destinationTarget: '_top'
    // });

    // videojs.getPlayer().bug({
    //     height: 50,
    //     imgSrc: this.licenseService.getLogo(),
    //     // link: 'http://www.leapest.com',
    //     opacity: 0.5,
    //     padding: '8px',
    //     position: 'br',
    //     width: 50
    //   });
  }

  private url: SafeResourceUrl;
  private player: any;
  private videoElem: ElementRef;
  logo: string;
  api: VgAPI;
  private domain: any;

  constructor(private route: ActivatedRoute,
    private licenseService: LicenseService,
    private sanitizer: DomSanitizer,
    private domainService: DomainService,
    private configService: ConfigService) {
    super();
  }

  ngOnInit() {

    const deliverableId = this.route.snapshot.params['deliverableId'];
    this.logo = this.licenseService.getLogo();
    this.loading();
    this.licenseService.getEvaluationVideoUrl(deliverableId)
      .bindToLifecycle(this)
      .subscribe(({ data }) => {
        this.getType(data);
        this.url = data;
        this.ready();
      }, err => this.error());

    this.domain = this.domainService.getDomain();
  }

  getType(filename: string) {
    if (filename.includes('mp4') || filename.includes('mov')) {
      this.type = 'video/mp4';
    }
    else if (filename.includes('ogg')) {
      this.type = 'video/ogg';
    }
    else if (filename.includes('webm')) {
      this.type = 'video/webm';
    }
    else {
      throw new Error('Unknown extension:');
    }
    return;
  }

  getSphinxUrl(bucket: string, file: string): string {
    let result = this.configService.get('server').sphinx +
      this.configService.get('endpoints').sphinx.download.api +
      '/solar/jwt/' + bucket + '/' + file;
    return result;
  }

  onPlayerReady(api: VgAPI) {
    this.api = api;
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );

    this.api.getDefaultMedia().subscriptions.pause.subscribe(_ => console.log('Player paused'));
  }
  // this.player.bug({
  //   height: 50,
  //   imgSrc: 'http://cdn.teamcococdn.com/image/frame:1/teamcoco_twitter_128x128.png',
  //   // link: 'http://www.leapest.com',
  //   opacity: 0.5,
  //   padding: '8px',
  //   position: 'br',
  //   width: 50
  // });
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/video/video.component.ts